// extracted by mini-css-extract-plugin
export default {"chartCard":"PieChartCard_chartCard__7Vn+R","title":"PieChartCard_title__WzTM1","chartWrapper":"PieChartCard_chartWrapper__HJvLs"};